import { useState } from 'react';
import { useSelector } from 'react-redux';
import { ClipboardList, FileText } from 'lucide-react';
import { getGorevStats, getRaporStats } from '@mocks/santiyeGunlugu';
import Gorevlerim from './Gorevlerim';
import GunlukRapor from './GunlukRapor';
import clsx from 'clsx';

export default function SantiyeGunlugu() {
    const { selectedConstruction, showAllConstructions } = useSelector((state) => state.construction);
    const { user } = useSelector((state) => state.auth || {});
    const insaatId = showAllConstructions ? null : selectedConstruction?.id;

    // Rol tespiti. Mock ortamında user.role genellikle 'admin' gelir.
    // Gerçek Supabase entegrasyonunda: profiles.role alanına göre değerlendirilecek.
    // Şantiye şefi rolü: 'sef', diğer tüm roller admin görünümü alır.
    const isSef = user?.role === 'sef';
    const isAdmin = !isSef; // varsayılan: admin görünümü (müteahhit/superadmin vs.)
    // Şef ID'si: Supabase'de profiles.id ile eşleşecek. Mock'ta sabit 'sef-1'.
    const sefId = isSef ? (user?.id || 'sef-1') : null;

    const [activeTab, setActiveTab] = useState('gorevler');

    const gorevStats = getGorevStats(insaatId);
    const raporStats = getRaporStats(insaatId);

    const tabs = [
        {
            key: 'gorevler',
            label: 'Görevlerim',
            icon: ClipboardList,
            badge: gorevStats.bugunBekleyen > 0 ? gorevStats.bugunBekleyen : null,
        },
        {
            key: 'rapor',
            label: 'Günlük Rapor',
            icon: FileText,
            badge: null,
        },
    ];

    return (
        <div className="p-4 md:p-6 space-y-6">
            {/* Page Header */}
            <div className="border-b border-border-light pb-5">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3">
                    <div>
                        <h1 className="text-2xl font-bold text-text-primary">Şantiye Günlüğü</h1>
                        <p className="text-text-tertiary text-sm mt-1">
                            {showAllConstructions ? 'Tüm inşaatlar' : (selectedConstruction?.name || '—')}
                            {isAdmin ? ' · Yönetici görünümü' : ' · Şantiye şefi görünümü'}
                        </p>
                    </div>
                    {/* Özet badges */}
                    <div className="flex items-center gap-3 flex-wrap">
                        <div className="flex items-center gap-2 px-3 py-1.5 bg-warning/10 rounded-lg">
                            <span className="w-2 h-2 rounded-full bg-warning" />
                            <span className="text-sm text-warning font-medium">{gorevStats.bugunBekleyen} bekleyen görev</span>
                        </div>
                        {gorevStats.acilBekleyen > 0 && (
                            <div className="flex items-center gap-2 px-3 py-1.5 bg-error/10 rounded-lg">
                                <span className="w-2 h-2 rounded-full bg-error" />
                                <span className="text-sm text-error font-medium">{gorevStats.acilBekleyen} acil</span>
                            </div>
                        )}
                    </div>
                </div>

                {/* Tab Navigation */}
                <div className="flex items-center gap-1 mt-5">
                    {tabs.map(tab => (
                        <button
                            key={tab.key}
                            onClick={() => setActiveTab(tab.key)}
                            className={clsx(
                                "flex items-center gap-2 px-5 py-2.5 text-sm font-medium rounded-xl transition-all",
                                activeTab === tab.key
                                    ? "bg-primary text-white shadow-sm"
                                    : "text-text-secondary hover:text-text-primary hover:bg-bg-hover"
                            )}
                        >
                            <tab.icon size={16} />
                            {tab.label}
                            {tab.badge && (
                                <span className={clsx(
                                    "min-w-[20px] h-5 px-1 rounded-full text-xs font-bold flex items-center justify-center",
                                    activeTab === tab.key ? "bg-white/20 text-white" : "bg-warning text-white"
                                )}>
                                    {tab.badge}
                                </span>
                            )}
                        </button>
                    ))}
                </div>
            </div>

            {/* Tab Content */}
            {activeTab === 'gorevler' ? (
                <Gorevlerim insaatId={insaatId} gorevStats={gorevStats} />
            ) : (
                <GunlukRapor insaatId={insaatId} isAdmin={isAdmin} sefId={sefId} raporStats={raporStats} />
            )}
        </div>
    );
}
